import { Grid, TextField, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { regexTestIsRGBVector } from '../helpers';

export const StainVector: React.FC<{
  stainVector: number[];
  setVector: (newVector: number[]) => void;
}> = ({ stainVector, setVector }) => {
  const [temporaryVector, setTemporaryVector] = React.useState('');

  const currentVector = useMemo(() => JSON.stringify(stainVector || [0, 0, 0]), [stainVector]);

  const isValidVector = (vector: string) => {
    return !vector || regexTestIsRGBVector.test(vector);
  };

  return (
    <Grid item container xs={8} direction="row" justifyContent="space-between" alignItems="center" mb={1}>
      <Grid item xs={10}>
        <TextField
          size="small"
          label="Vector"
          value={temporaryVector || currentVector}
          onChange={(event) => {
            if (isValidVector(event.target.value)) {
              setVector(JSON.parse(event.target.value));
            }
            setTemporaryVector(event.target.value);
          }}
        />
      </Grid>
      {Boolean(temporaryVector) && temporaryVector !== currentVector && (
        <Grid item xs={2}>
          {!isValidVector(temporaryVector) && (
            <Typography variant="caption" color="error">
              Invalid JSON array
            </Typography>
          )}
        </Grid>
      )}
    </Grid>
  );
};
